import { ArrowRightSmall } from '@peacecover/icon';

interface ToastActionWhiteProps {
  text: string;
  rightText: string;
  emoji?: string;
  onClick?: () => void;
  hasBorder?: boolean;
}

const ToastActionWhite = ({
  text,
  rightText,
  emoji = '✨',
  onClick,
  hasBorder = false
}: ToastActionWhiteProps) => {
  const ButtonContent = (
    <button
      type="button"
      onClick={() => onClick?.()}
      className="flex items-center justify-between w-full gap-[4px] p-[12px] bg-pure-white dark:bg-pure-black rounded-[4px] shadow-[0_0_3px_0_rgba(0,0,0,0.06),0_0_12px_0_rgba(0,0,0,0.03)]"
    >
      <p className="text-[14px] font-medium text-text-main-lv2 leading-[17px]">
        <span className="mr-[4px]">{emoji}</span>
        {text}
      </p>
      <div className="flex items-center gap-[4px]">
        <p className="text-[13px] font-semibold text-text-primary leading-[16px]">{rightText}</p>
        <ArrowRightSmall size={16} className="text-text-primary" />
      </div>
    </button>
  );

  if (!hasBorder) return ButtonContent;

  return (
    <div className="p-[1px] rounded-[5px] bg-[linear-gradient(102deg,#860EFF_0%,#2DE7D1_44%,#C855FF_100%)]">
      {ButtonContent}
    </div>
  );
};

export default ToastActionWhite;
